<template>
  <v-dialog v-model="openDialog" fullscreen>
    <v-card class="fullscreen-dialog">
      <v-container>
        <v-row class="payment-container" align="center" justify="center">
          <v-col cols="8" class="container">
            <h1 v-if="isSending" class="white--text mb-7 text-center">
              Impressão em andamento...
            </h1>

            <div class="card container-print-invoice text-center">
              <img src="@/assets/ic-print-options.png" class="" alt="" />

              <strong v-if="isSending"
                >Aguarde a impressão e <br />
                retire o boleto abaixo</strong
              >
              <strong v-if="!isSending && isFullSending && !isDifferentBank">{{
                isSendingSuccess
                  ? "Impressão realizada com sucesso."
                  : "Houve um problema com a impressão, por favor tente novamente ou use outro totem"
              }}</strong>

              <strong v-if="isDifferentBank">
                Desculpa, mas não é possível imprimir o seu boleto<br />Neste
                momento é possível apenas enviar por SMS ou por e-mail.
              </strong>
            </div>

            <div v-if="isFullSending">
              <v-btn
                class="py-6 mt-6 payment-button"
                color="primary"
                block
                @click="goBack"
                @click.right="goBack"
              >
                <v-icon left light color="black" size="24" class="mr-2 icon-white"
                  >mdi-arrow-left</v-icon
                >
                Voltar
              </v-btn>
              <v-btn
                class="py-6 mt-6 payment-button"
                color="white"
                block
                @click="userLogout"
                @click.right="userLogout"
              >
                <v-icon left light color="black" size="25" class="mr-2"
                  >mdi-exit-to-app</v-icon
                >
                Encerrar sessão
              </v-btn>
            </div>

            <img
              src="@/assets/ic-arrow-down-large.png"
              class="icon-arrow"
              alt=""
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { signOut } from "@/controllers/user.controller";

import closePageInvoices from "@/store/closePageInvoices.store";

import invoicesStore from "@/store/invoices.store";
import userStore from "@/store/user.store";

import config from "@/config.js";

import apiPrint from "@/services/apiPrint.service";
import { dateFormat } from "@/services/date.service";

import axios from "axios";

export default {
  name: "PrintInvoiceDialog",
  props: {
    openDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSending: false,
      isFullSending: false,
      isSendingSuccess: false,
      isDifferentBank: false,
      handleSetTimeout: "",
      time: 240000,
      timeSetInterval: 2000,
      responseLineCode: "",
      responseBarcode: "",
    };
  },
  methods: {
    handleSetTimeoutOutput() {
      clearTimeout(this.handleSetTimeout);
      signOut();
    },
    goBack() {
      this.isSendingSuccess = false;
      this.isFullSending = false;

      clearTimeout(this.handleSetTimeout);

      closePageInvoices.commit("setIsToClose", true);

      this.$emit("close", true);
    },
    userLogout() {
      clearTimeout(this.handleSetTimeout);

      signOut();
    },
    async handlePrintInvoice() {
      this.isSending = true;

      const invoices = invoicesStore.getters.invoices;

      const user = userStore.getters.user;

      const date = new Date();

      try {
        for (const invoice of invoices) {
          const payload = {
            get_barcode: {
              banking_billet_id: invoice.id,
              send_barcode: false,
              return_type: "line",
            },
          };

          const payloadBarCode = {
            get_barcode: {
              banking_billet_id: invoice.id,
              send_barcode: false,
              return_type: "barcode",
            },
          };

          const fetchLinecode = axios.post(
            `${config.urlApiTely}/get_barcode`,
            payload
          );
          const fetchBarcode = axios.post(
            `${config.urlApiTely}/get_barcode`,
            payloadBarCode
          );

          const responses = await axios.all([fetchLinecode, fetchBarcode]);

          this.responseLineCode = responses[0].data.result;
          this.responseBarcode = responses[1].data.result;

          const data = {
            address: {
              city: invoice.address.city,
              complement: invoice.address.complement,
              country: invoice.address.country,
              district: invoice.address.district,
              neighborhood: invoice.address.neighborhood,
              number: invoice.address.number,
              state: invoice.address.state,
              street: invoice.address.street,
              zipcode: invoice.address.zipcode,
            },
            bank: invoice.bank.toString().padStart(3, '0'),
            carteira: 2,
            bankNumber: invoice.bank_number,
            createdDate: dateFormat(date),
            documentDate: dateFormat(date),
            documentNumber: invoice.document_number,
            documentPayer: user.CNPJ_CNPF,
            dueDate: invoice.due_date,
            linhaDigitavel: this.responseLineCode,
            codigoDeBarras: this.responseBarcode,
            namePayer: user.nome,
            valueDiscount: invoice.value_discount,
            valueFine: invoice.value_fine,
            valueInit: invoice.value_init,
            valueInterest: invoice.value_interest,
            valueUp: invoice.value_up,
          };

          console.log(`linhaDigitavel ${data.linhaDigitavel}`);
          console.log(`codigoDeBarras ${data.codigoDeBarras}`);
          console.log(`boleto ${JSON.stringify(data)}`);
          await apiPrint.post("/api/geraBoleto", data);

        }

        this.isFullSending = true;
        this.isSendingSuccess = true;
        this.isSending = false;
      } catch (error) {
        this.isFullSending = true;
        this.isSendingSuccess = false;
        this.isSending = false;

        console.log(error);
      }
    },
  },
  mounted() {
    this.handlePrintInvoice();

    this.handleSetTimeout = setTimeout(this.handleSetTimeoutOutput, this.time);
  },
  beforeDestroy() {},
};
</script>

<style scoped>
.fullscreen-dialog .payment-container {
  height: 100vh;
}

.fullscreen-dialog .payment-button {
  box-shadow: 0px 4px 0px rgba(255, 255, 255, 0.4),
    0px 6px 16px rgba(35, 41, 46, 0.2) !important;
  border-radius: 16px !important;
  font-weight: 600 !important;
  font-size: 17px !important;
}

.white--text {
  color: #1a237e !important;
}

.container .icon-arrow {
  position: absolute;
  left: 48px;
  bottom: 64px;
}

h1 {
  font-size: 26px;
  font-weight: 600;
  line-height: 32.76px;
  letter-spacing: 0.15px;
}

.container-print-invoice {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.container-print-invoice img {
  width: 120px;
  height: 120px;
  margin-bottom: 32px;
}
.container-print-invoice strong {
  font-weight: 600;
  font-size: 21px;
  line-height: 26px;
  letter-spacing: 0.05px;
  color: rgba(22, 33, 45, 0.8);
}

.icon-white {
  color: white !important;
}
</style>